/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useWalletsMixed from './useWalletsMix';
import { Currency } from '../components/common/Form/config';
import { ExchangeResponse } from '../services/rate/types';
import { useAppDispatch } from '../store';
import { selectProfileData } from '../pages/profile/store/selectors';
import { fetchWallets } from '../modules/wallets/store';
import { selectCombinedBalanceData } from '../modules/combined_balance/selectors';
import useBoolean from './useBoolean';
import { fetchCombinedBalance } from '@/modules/combined_balance/store';

type IAllRates = Record<Currency, ExchangeResponse>;

const useCombineBalances = () => {
  const dispatch = useAppDispatch();
  const dataMixed = useWalletsMixed();
  const combinedBalanceAmount = useSelector(selectCombinedBalanceData);
  const userProfile = useSelector(selectProfileData);
  const [loading, { setTrue: showLoading, setFalse: hideLoading }] =
    useBoolean(true);
  const [allRates] = useState<IAllRates>();
  const [fixedGeneralBalance, setFixedGeneralBalance] = useState<
    number | undefined
  >(0);
  const enterpriseId = useMemo(
    () => userProfile?.company?.enterpriseId,
    [userProfile]
  );

  const handleReloadWallets = useCallback(() => {
    showLoading();
    if (enterpriseId) {
      dispatch(fetchWallets(enterpriseId));
      dispatch(fetchCombinedBalance(enterpriseId));
    }
  }, [enterpriseId]);

  useEffect(() => {
    if (combinedBalanceAmount.data) {
      setFixedGeneralBalance(combinedBalanceAmount.data.combinedBalance);
      hideLoading();
    }
  }, [combinedBalanceAmount]);

  return {
    reloadWallet: handleReloadWallets,
    fixedGeneralBalance,
    loadingBalances: loading || combinedBalanceAmount.loading,
    loadingBalancesError: combinedBalanceAmount.error,
    dataMixed,
    allRates,
  };
};

export default useCombineBalances;
